import { PermissionCheckerContext } from 'context/PermissionCheckerProvider';
import { useContext } from 'react';

export const usePermissionChecker = () => {
  const permissionChecker = useContext(PermissionCheckerContext);
  if (!permissionChecker) {
    throw new Error('usePermissionCheckerInstance must be used within a Provider');
  }

  return permissionChecker;
};
